<nz-card nzTitle="Frontend Development Milestones" class="em-area">
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <!-- Outside the error branch on purpose: changing the selection is what triggers a
         new request, so hiding it alongside the table left no way to recover. -->
    <em-workcenter-selector
      [loading]="(paginatorRef.loading$ | async) ?? false"
      (selectedPmOrders)="selectedPmOrdersChange($event)"
    ></em-workcenter-selector>

    <ng-container *ngIf="pmOperationsError$ | async as errorMsg; else resultTemplate">
      <em-error-result [subTitle]="errorMsg"></em-error-result>
    </ng-container>

    <ng-template #resultTemplate>
      <ng-container *ngIf="developmentMilestones$ | async as developmentMilestones">
        <nz-table
          #developmentMilestonesRef
          [nzData]="developmentMilestones.data"
          [nzLoading]="(paginatorRef.loading$ | async) ?? false"
          [nzTotal]="developmentMilestones.total ?? 0"
          nzSize="small"
          nzShowSizeChanger
          [nzFrontPagination]="false"
          [(nzPageSize)]="perPage"
          [nzPageSizeOptions]="[5, 10, 20, 30]"
          [(nzPageIndex)]="pageIndex"
          (nzPageIndexChange)="paginatorRef.setPage($event)"
          (nzPageSizeChange)="pageSizeChange($event)"
        >
          <thead>
            <tr>
              <th>Responsible</th>
              <th>Status</th>
              <th>Status changed date</th>
              <th>Planned delivery date</th>
              <th>Latest finish date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of developmentMilestonesRef.data; trackBy: trackByRef">
              <td>{{ data.operationShortText }}</td>
              <td>{{ data.systemStatus }}</td>
              <td>{{ data.actualFinishExecutionDate | date: 'shortDate' }}</td>
              <td>{{ data.earliestFinishExecutionDate | date: 'shortDate' }}</td>
              <td>{{ data.constraintEndDate | date: 'shortDate' }}</td>
              <td></td>
            </tr>
          </tbody>
        </nz-table>
      </ng-container>
    </ng-template>
  </nz-skeleton>
</nz-card>
